import React,{useTransition} from "react";
import '../../Styles/Components/PublicForms/Splash_Page.css';
import { Navigate, useNavigate } from "react-router-dom";
import logo from '../../Images/mouood-Logo-Subscription.png';



const Splash_Page = ()=>
{

    const [isPending, startTransition] = useTransition()
    const Navigate = useNavigate();

    
    setTimeout(() => {
        startTransition(() => {
        Navigate('/Login');
        });
    }, 4000);

    function login()
    {
        Navigate('/Login');
    }

    return(
        <div className="Splash">
{/* 
            <h1> السلام علیک یا صاحب الزمان</h1>

            <h3> به سیستم اشتراک موعود خوش آمدید</h3>
            <button type="button" class="btn" onClick={()=>login()}>ورود</button> */}

            <img src={logo} />



        </div>
    )
    
}

export default Splash_Page;